import { Directive } from '@angular/core';
import { NG_VALIDATORS, Validator, ValidationErrors, FormControl } from '@angular/forms';
import { ValidationTypes } from './validator-const.model';
import { BaseValidator } from './base.directive';
import { TranslationService } from '../../common/services/translation.service';

const EMAIL_REGEX_WITH_UNICODE_CHARS = /^(?=.{1,320}$)(?=.{1,64}@)[-!#$%&'*+/0-9=?\p{L}\p{M}^_`{|}~]+(\.[-!#$%&'*+/0-9=?\p{L}\p{M}^_`{|}~]+)*@[\p{L}\p{M}0-9]([\p{L}\p{M}0-9-]{0,61}[\p{L}\p{M}0-9])?(\.[\p{L}\p{M}0-9]([\p{L}\p{M}0-9-]{0,61}[\p{L}\p{M}0-9])?)*$/u;

@Directive({
    selector: `[cpqEmail]`,
    providers: [{ provide: NG_VALIDATORS, useExisting: EmailDirective, multi: true }],
    standalone: false
})
export class EmailDirective extends BaseValidator implements Validator {

    constructor(private translationService: TranslationService) {
        super();
    }

    validate(c: FormControl<string>): ValidationErrors {
      let isValid = true;
      if (c.value) {
          isValid = EMAIL_REGEX_WITH_UNICODE_CHARS.test(c.value);
      }
      return isValid ? null : this.createMessage(ValidationTypes.cpqEmail, this.translationService.translate('Admin.Validation.InvalidEmail'));
    }
}


